export const STRIPE_QUERY_PARAMS = {
   REDIRECT_STATUS: 'redirect_status',
   PAYMENT_INTENT: 'payment_intent',
   PAYMENT_INTENT_CLIENT_SECRET: 'payment_intent_client_secret'
};

export const STRIPE_REDIRECT_STATUS = {
   SUCCEEDED: 'succeeded',
   FAILED: 'failed'
};
